import { Dialog, DialogContent } from "@mui/material";
import { Button } from "antd";
import React, { useContext } from "react";
import { PlaybackContext } from "../LayoutPlayback";
import { TiTick } from "react-icons/ti";

function SimulationReadyPop({ open, handleClose }) {
  const { start_init } = useContext(PlaybackContext);
  return (
    <Dialog
      style={{ zIndex: 9999 }}
      className="simulation-ready-pop"
      open={open}
      onClose={() => {}}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent className="simulation-ready-pop-content">
        <div className="text-content">
          <span className="text">SIMULTION READY</span>
          <TiTick style={{ width: "2em", height: "2em" }} color="green" fill="green" />
        </div>

        <Button
          onClick={() => {
            start_init();
            handleClose();
          }}
        >
          Click to start {}
        </Button>
      </DialogContent>
    </Dialog>
  );
}

export default SimulationReadyPop;
